































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderAddButton from '@/components/builder/BuilderAddButton.vue'
import { ChatStubState } from './BuilderChat.vue'
import BuilderDot from '@/components/builder/BuilderDot.vue'

@Component({
  components: {
    BuilderAddButton,
    BuilderButton,
    BuilderTooltip,
    BuilderDevice,
    BuilderDefaultContainer,
    BuilderDot,
  },
})
export default class BuilderChatPersonalAvatar extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: ChatStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  @Ref('file') readonly fileInput!: HTMLInputElement

  file: Blob | File | string | null = null

  processing = false

  get isNextStepDisabled(): boolean {
    return !this.file
  }

  @Watch('file')
  onFileChange(file: File | string | null): void {
    this.$emit('input', {
      channels: this.value.channels.map((c, i) =>
        i === 1
          ? {
              ...c,
              image: file,
              changedFile: file,
            }
          : c
      ),
    })
  }

  onFileInputChange(files: File[]): void {
    const file = files[0]
    this.file = file
  }

  onUploadPhotoClick(): void {
    if (!this.file) {
      this.fileInput.click()
    } else {
      this.file = null
    }
  }

  async onNextClick(): Promise<void> {
    if (this.isNextStepDisabled) {
      return
    }

    this.processing = true

    try {
      if (this.file instanceof Blob) {
        await this.$store.dispatch('builder/mutateChannel', {
          id: this.value.channels[1].id,
          isPersonal: true,
          image: this.file,
        })
      }

      this.$emit('next')
    } catch (e) {
      this.$toasted.error(e.message)
    }

    this.processing = false
  }

  async onStubStateReady(): Promise<void> {
    if (this.value.channels.length < 2) {
      this.$emit('back')
      return
    }

    this.file = this.value.channels[1]?.image

    this.$emit('input', {
      channels: this.value.channels.map((c, i) => (i === 1 ? { ...c, highlight: 'avatar' } : c)),
    })
  }
}
